import { provideStates } from '@ngxs/store';
import { EjournalSessionState } from './ejournal-session.state';

export const ejournalSessionStateProvider = provideStates([
  EjournalSessionState,
]);
